import { TenantConfig } from './tenants/TenantConfig';
import { extractSlug } from '@/config/extractSlug';

const TENANT_URL = window.location.hostname;

export default async (isDefault: boolean = false): Promise<TenantConfig> =>
  (await import(`./tenants/${isDefault ? 'default' : extractSlug(TENANT_URL)}.ts`)).default;
